module.exports = __webpack_public_path__ + "static/media/Element_1_treatment.0e65d776.svg";